<ng-container *transloco="let t">
    <vds-drawer [config]="drawerConfig" [open]="drawerOpen()" (close)="closeDrawer()">
        <vds-sub-nav-toolbar class="sticky top-0 z-10 shrink-0 items-center justify-between bg-white">
            @if (drawerView() === "announcement-details") {
                <a
                    vds-text-link
                    leadingIcon="arrow-left"
                    [routerLink]="[]"
                    [queryParams]="{ sbView: 'announcements', sbViewId: null }"
                    queryParamsHandling="merge"
                >
                    {{ t("backToWhatsNew") }}
                </a>
            } @else {
                <a
                    vds-sub-nav-item
                    [routerLink]="[]"
                    [queryParams]="{ sbView: 'announcements' }"
                    queryParamsHandling="merge"
                    [active]="drawerView() === 'announcements'"
                >
                    {{ t("whatsNew") }}
                </a>
                <a
                    vds-sub-nav-item
                    [routerLink]="[]"
                    [queryParams]="{ sbView: 'early-access' }"
                    queryParamsHandling="merge"
                    [active]="drawerView() === 'early-access'"
                >
                    {{ t("earlyAccess") }}
                </a>
            }
            <ng-container ngProjectAs="[vdsToolbarActions]">
                <button type="button" vds-icon-button [attr.aria-label]="t('appTextClose')" (click)="closeDrawer()">
                    <vds-icon name="close-large" />
                </button>
            </ng-container>
        </vds-sub-nav-toolbar>
        @switch (drawerView()) {
            @case ("announcements") {
                @defer {
                    <div class="h-full px-16">
                        <vo-announcements-list />
                    </div>
                }
            }
            @case ("announcement-details") {
                @defer {
                    <div class="flex h-full flex-col overflow-hidden px-16">
                        <vo-announcements-details />
                    </div>
                }
            }
            @case ("early-access") {
                @defer {
                    <vo-bf-tab />
                }
            }
        }
    </vds-drawer>
</ng-container>
